module.exports = __webpack_public_path__ + "static/img/praise-and-worship.fc5a68a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ministries/praise-and-worship.jpg
// module id = tcgq
// module chunks = 1